import React from 'react';
import { Box, Link } from '@xometry/xometry_loft';
import { WWW_ORIGIN } from '../../../config';

export const ORGANIZATION_INVITE_NOT_PENDING =
  'Organization Invite Not Pending';

const getPageCopy = (
  orgName: string | null,
  acceptInvite: string | null,
  getOrgError: string | undefined,
  acceptInviteError: string | undefined,
  isLoading: boolean
) => {
  // No org found for the org id or logged in user does not have permission to see org data
  if (
    !orgName &&
    acceptInviteError !== ORGANIZATION_INVITE_NOT_PENDING &&
    !isLoading
  ) {
    return {
      title: 'You Have Not Joined An Organization',
      body: () => (
        <Box>
          There was problem adding you to an organization team. If the problem
          continues, contact{' '}
          <Link href="mailto:support@xometry.com">support@xometry.com</Link> for
          assistance.
        </Box>
      ),
    };
  }
  // User has joined successfully
  if (acceptInvite === 'true' && !(getOrgError || acceptInviteError)) {
    return {
      title: `You Have Joined ${orgName}`,
      body: () => (
        <Box>
          Now that you have accepted {orgName}&apos;s invitation, your team will
          have access to an overview of the organization&apos;s ongoing projects
          with Xometry.
        </Box>
      ),
    };
  }
  // User has declined successfully
  if (acceptInvite === 'false' && !(getOrgError || acceptInviteError)) {
    return {
      title: `You Have Not Joined ${orgName}`,
      body: () => (
        <Box>
          Your team will not have access to an overview of your ongoing projects
          with Xometry. If you declined this invitation by mistake, contact{' '}
          <Link href="mailto:support@xometry.com">support@xometry.com</Link> to
          resend the invitation.
        </Box>
      ),
    };
  }
  // User has previously accepted
  if (
    acceptInvite === 'true' &&
    acceptInviteError === ORGANIZATION_INVITE_NOT_PENDING
  ) {
    return {
      title: `You Have Previously Joined ${orgName}`,
      body: () => (
        <Box>
          You have already accepted the invitation to join {orgName}. If you
          accepted this invitation by mistake, contact{' '}
          <Link href="mailto:support@xometry.com">support@xometry.com</Link> for
          assistance.
        </Box>
      ),
    };
  }

  // default
  return {
    title: 'You Have Not Joined An Organization',
    body: () => (
      <Box>
        There was problem adding you to an organization team. If the problem
        continues, contact{' '}
        <Link href="mailto:support@xometry.com">support@xometry.com</Link> for
        assistance.
      </Box>
    ),
  };
};

const getValidatedRedirectUrl = (redirectUrl: string | null) => {
  if (redirectUrl && redirectUrl.includes(WWW_ORIGIN)) return redirectUrl;
  return `${WWW_ORIGIN}/quoting`;
};

export default {
  getPageCopy,
  getValidatedRedirectUrl,
};
